// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1e8lN","top":"styles_top__1mjn3","left":"styles_left__1fg8l","description":"styles_description__2re6k"};